import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";

const AdmissionCard = () => {
  const youtubeVideoId = "kYXUNrXgXUI";
  const iframeRef = useRef(null);

  useEffect(() => {
    const isLocalhost = window.location.hostname === "localhost";

    if (!isLocalhost) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);

      window.onYouTubeIframeAPIReady = () => {
        if (iframeRef.current) {
          new window.YT.Player(iframeRef.current, {
            playerVars: { origin: window.location.origin },
            events: {
              onStateChange: (event) => {
                if (event.data === window.YT.PlayerState.ENDED) {
                  event.target.stopVideo();
                }
              },
            },
          });
        }
      };

      return () => {
        delete window.onYouTubeIframeAPIReady;
        document.body.removeChild(tag);
      };
    }
  }, []);

  return (
    <section
      className="relative w-screen left-1/2 right-1/2 mx-[-50vw] overflow-hidden
        -mt-12 md:-mt-16 lg:-mt-20
        mb-[-80px] md:mb-[-74px] lg:mb-[-144px]
        pt-16 md:pt-20 lg:pt-24
        pb-20 md:pb-24 lg:pb-28 bg-gradient-to-br from-gray-300 via-white to-gray-400 "
      
      aria-labelledby="admission-heading"
    >
      {/* Content */}
      <article
        className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10"
        itemScope
        itemType="https://schema.org/Article"
      >
        <div className="flex flex-col lg:flex-row gap-8 xl:gap-12">
          {/* LEFT TEXT */}
          <motion.div
            className="lg:w-1/2 space-y-6 md:space-y-8 text-gray-900"
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <header>
              <h1
                id="admission-heading"
                className="text-3xl sm:text-4xl md:text-5xl font-bold font-serif tracking-tight"
              >
                Step In. Shine Ahead!
              </h1>
              <div className="w-20 h-1 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full"></div>
            </header>

            <p className="text-base md:text-lg leading-relaxed md:leading-loose sm:text-4xl font-serif mb-4">
              Give your child the best start at{" "}
              <strong className="text-yellow-600 font-semibold">STVMHS</strong>,
              where the curriculum meets a nurturing, student-centric
              environment.
            </p>

            <p className="text-base md:text-lg font-serif leading-relaxed md:leading-loose">
              Visit us on social media to explore more about our vibrant
              community. Join the STVMHS family, where every child's journey is
              filled with opportunity and growth.
            </p>

            <div className="pt-2 md:pt-4">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdW5AwmV3DSirB38HJofn3US9UFnEAHIaUji_2Ayd4a8AZ92Q/viewform"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Enroll now at STVMHS"
              >
                <StyledButton>Enroll Now</StyledButton>
              </a>
            </div>
          </motion.div>

          {/* RIGHT: VIDEO */}
          <motion.div
            className="lg:w-1/2"
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <div className="rounded-xl overflow-hidden shadow-xl transition-shadow duration-300 aspect-w-16 aspect-h-9">
              <div className="relative pt-[56.25%]">
                <iframe
                  ref={iframeRef}
                  src={`https://www.youtube.com/embed/${youtubeVideoId}?enablejsapi=1&rel=0`}
                  className="absolute top-0 left-0 w-full h-full border-0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="STVMHS Admission Video"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </article>
    </section>
  );
};

const StyledButton = styled.button`
  font-size: 18px;
  cursor: pointer;
  background: radial-gradient(100% 100% at 100% 0%, #ffd700 0%, #ffa500 100%);
  padding: 0 2em;
  border-radius: 0.3em;
  height: 2.6em;
  color: #000;
  font-weight: bold;
  transition: 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

export default AdmissionCard;
